import '@formatjs/intl-listformat/polyfill';
import '@formatjs/intl-listformat/locale-data/en';
import { capitalize } from 'lodash';

export function formatPropertyTypes(property_sub_type: string[]) {
    if (!property_sub_type.length) {
        return 'All property';
    }

    const propertySubTypeOptions: { [key: string]: string } = {
        detached: 'detached houses',
        semi_detached: 'semi-detached houses',
        terraced: 'terraced houses',
        flats: 'flats',
        bungalow: 'bungalows',
        farms_land: 'farms/land',
        park_home: 'park homes'
    };

    const propertyTypes = property_sub_type
        .map((type) => propertySubTypeOptions[type])
        .filter((i) => i);

    const formatter = new Intl.ListFormat('en-GB', {
        style: 'long',
        type: 'conjunction'
    });

    return capitalize(formatter.format(propertyTypes));
}
